module.exports = __webpack_public_path__ + "img/tracteurvert_off.c74ddc73.gif";